import ProfileBenachrichtigungen from './ProfileBenachrichtigungen';

export default ProfileBenachrichtigungen;
